import { Form } from "./types";
import { useCallback } from "react";
import InvoiceLineRowForm from "./InvoiceLineRowForm";

const AddInvoiceLineRow = (props: {
  deliveryId: string;
  clientId?: string;
  onAdd: (line: any) => Promise<string[]>;
  onCancel: () => void;
  onAfterCreate: (newLineIds: string[]) => void;
  noCheckboxes: boolean;
  showStatusColumn?: boolean;
}) => {
  const { onAdd, onAfterCreate, clientId } = props;

  const handleSubmit = useCallback(
    async (values: Form) => {
      const response = await onAdd({
        ...values,
        quantity: values.quantity.toString(),
        amount: values.amount.toString(),
      });
      onAfterCreate(response);
    },
    [onAdd, onAfterCreate]
  );

  return (
    <InvoiceLineRowForm
      defaultValues={{
        description: "",
        productId: null,
        unitId: null,
        quantity: "1",
        amount: "",
        discountPercentage: "",
      }}
      clientId={clientId}
      onSubmit={handleSubmit}
      {...props}
    />
  );
};

export default AddInvoiceLineRow;
